import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { saveUserData } from "../utils/secureStroge";

function AuthModal() {
  const [showLogin, setShowLogin] = useState(true);
  const [loginPasswordVisible, setLoginPasswordVisible] = useState(false);
  const [signupPasswordVisible, setSignupPasswordVisible] = useState(false);
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [signupData, setSignupData] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

  // Handle form inputs
  const handleLoginChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSignupChange = (e) => {
    setSignupData({ ...signupData, [e.target.name]: e.target.value });
  };

  // API Calls
  const callApi = async (url, data) => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const response = await fetch(`${API_BASE_URL}${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok) {
        return result;
      } else {
        throw new Error(result.message || "Something went wrong");
      }
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // ✅ FIXED Login Handler
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await callApi("/auth/login", loginData);

      saveUserData({
        accessToken: result.accessToken,
        refreshToken: result.refreshToken,
        user: result.user,
      });

      window.dispatchEvent(new Event("authChanged"));

      navigate("/profile");

      setSuccess("Login successful! Redirecting...");

      // 🔥 FIXED MODAL CLOSE
      setTimeout(() => {
        const modalEl = document.getElementById("authModal");

        if (modalEl) {
          // ❌ Bootstrap instance unreliable → force remove
          modalEl.classList.remove("show");
          modalEl.style.display = "none";
          modalEl.setAttribute("aria-hidden", "true");
        }

        // ✅ remove backdrop (VERY IMPORTANT)
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";

        // ✅ RESET EVERYTHING AFTER CLOSE
        setLoginData({ email: "", password: "" });
        setSignupData({
          full_name: "",
          email: "",
          phone_number: "",
          password: "",
        });
        setError("");
        setSuccess("");

        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
        setSuccess("");
        setError("");
        navigate("/profile");
      }, 1000);

      setLoginData({ email: "", password: "" });
      setError("");
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  // Signup Handler
  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await callApi("/auth/signup", signupData);

      setSuccess("Account created successfully!"); // show message

      setTimeout(() => {
        // Only clear messages, don't switch to login
        setSuccess("");
        setError("");
      }, 2000);

      // Optional: reset form fields
      setSignupData({
        full_name: "",
        email: "",
        phone_number: "",
        password: "",
      });
    } catch (err) {
      console.error("Signup error:", err);
      setError(err.message || "Signup failed");
    }
  };

  return (
    <div className="modal fade" id="authModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body pt-0">
            {showLogin ? (
              <>
                <h3 className="modal-title">Sign in to continue</h3>
                <p>Enter your email address for Login.</p>
                <form className="contact_form" onSubmit={handleLogin}>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter Your Email *"
                      value={loginData.email}
                      onChange={handleLoginChange}
                      required
                    />
                  </div>

                  <div className="form-group position-relative">
                    <input
                      type={loginPasswordVisible ? "text" : "password"}
                      name="password"
                      placeholder="Enter Your Password *"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      required
                    />
                    <span
                      className="toggle-password"
                      onClick={() =>
                        setLoginPasswordVisible(!loginPasswordVisible)
                      }
                    >
                      <i
                        className={`fa ${
                          loginPasswordVisible ? "fa-eye-slash" : "fa-eye"
                        }`}
                      ></i>
                    </span>
                  </div>

                  {error && (
                    <div className="alert alert-danger mt-2">{error}</div>
                  )}
                  {success && (
                    <div className="alert alert-success mt-2">{success}</div>
                  )}

                  <button
                    type="submit"
                    className="btn_style_one w-100"
                    disabled={loading}
                  >
                    {loading ? "Signing In..." : "Sign In"}
                  </button>

                  <p className="mt-3 text-center">
                    Don't have an account?{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowLogin(false);
                        setError("");
                        setSuccess("");
                      }}
                    >
                      Sign Up
                    </a>
                  </p>
                </form>
              </>
            ) : (
              <>
                <h3 className="modal-title">Create your account</h3>
                <form className="contact_form" onSubmit={handleSignup}>
                  <div className="form-group">
                    <input
                      type="text"
                      name="full_name"
                      placeholder="Enter Full Name *"
                      value={signupData.full_name}
                      onChange={handleSignupChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter Your Email *"
                      value={signupData.email}
                      onChange={handleSignupChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      name="phone_number"
                      placeholder="Enter Your Phone *"
                      value={signupData.phone_number}
                      onChange={handleSignupChange}
                      required
                    />
                  </div>

                  <div className="form-group position-relative">
                    <input
                      type={signupPasswordVisible ? "text" : "password"}
                      name="password"
                      placeholder="Enter Your Password *"
                      value={signupData.password}
                      onChange={handleSignupChange}
                      required
                    />
                    <span
                      className="toggle-password"
                      onClick={() =>
                        setSignupPasswordVisible(!signupPasswordVisible)
                      }
                    >
                      <i
                        className={`fa ${
                          signupPasswordVisible ? "fa-eye-slash" : "fa-eye"
                        }`}
                      ></i>
                    </span>
                  </div>

                  {error && (
                    <div className="alert alert-danger mt-2">{error}</div>
                  )}
                  {success && (
                    <div className="alert alert-success mt-2">{success}</div>
                  )}

                  <button
                    type="submit"
                    className="btn_style_one w-100"
                    disabled={loading}
                  >
                    {loading ? "Creating Account..." : "Create Account"}
                  </button>

                  <p className="mt-3 text-center">
                    Already have an account?{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowLogin(true);
                        setError("");
                        setSuccess("");
                      }}
                    >
                      Sign In
                    </a>
                  </p>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
